import controller from './controller';
import template from './template.html';

const controllerAs = 'dateEditorCtrl';
const bindings = {
  ngModel: '='
};

const require = {
  ngModelCtrl: 'ngModel'
};

export default {
  template,
  controller,
  controllerAs,
  bindings,
  require
};



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/dateEditor/index.js